module.exports = __webpack_public_path__ + "static/media/upsicon.5964bf37.svg";